var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"uploader",attrs:{"data-testid":"customer-import-uploader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }